import CouponsView from './CouponsView.vue';

export const couponsRoutesV2 = [
    {
        path: '/coupons',
        name: 'Coupons',
        component: CouponsView,
        meta: {
            requiresAuth: true,
            accessId: 'coupons',
        }
    }
]
